export default {
  addressValue(state) {
    const userInfo = state.userInfo;
    if (userInfo.districtCode) {
      return userInfo.province && userInfo.city && userInfo.province != userInfo.city
        ? userInfo.province + '-' + userInfo.city
        : userInfo.province || userInfo.city || '';
    }
    return '';
  },
  mobileBinded(state) {
    return state.userInfo.mobile;
  },
  basicInfoFilled(state) {
    const { name, card, sex } = state.userInfo;
    return !!(name && card && sex);
  },
  selectAdd(state) {
    const list = state.addressList || [];
    return list.length ? list.filter(val => val.defaultFlag == 1)[0] : {};
  }
};
